import { withVersions } from "v2/hocs/withVersions";
import CoinAvatarV1UI from "./CoinAvatar/v1";
import withCoinAvatar from "../hocs/withCoinAvatar";

const CoinAvatar = withVersions({
  v1: withCoinAvatar(CoinAvatarV1UI),
  v2: withCoinAvatar(CoinAvatarV1UI),
});

export default CoinAvatar;
